import api from '../config/axios-conf';

export const getTodayStats = () =>
    api.get('/statistics/today');

export const getReportAdmin = () =>
    api.get('/statistics/report-admin');

export const getReportAdminRevenue = () =>
    api.get('/statistics/report-admin-revenue');

export const getEndDayReport = (params) =>
    api.get('/statistics/end-day-report', { params });

export const getEndDayReportCustom = (params) =>
    api.get('/statistics/end-day-report-custom', { params });

export const getTopServices = (params) =>
    api.get('/statistics/top-services', { params });

export const getProfitChart = (params) =>
    api.get('/statistics/profit-chart', { params });

export const getProfitChartCustom = (params) =>
    api.get('/statistics/profit-chart-custom', { params });

export const getProfitDetail = (params) =>
    api.get('/statistics/profit-detail', { params });

export const getProfitDetailCustom = (params) =>
    api.get('/statistics/profit-detail-custom', { params });

export const getBillsDetailExportExcel = (params) =>
    api.get('/statistics/bills-detail-export-excel-custom', { params, responseType: 'blob' });

export const getRevenueBookExportPdf = (params) =>
    api.get('/statistics/bills-revenue-book-export-pdf-custom', { params, responseType: 'blob' });

export const getRevenueBookExportExcel = (params) =>
    api.get('/statistics/bills-revenue-book-export-excel-custom', { params, responseType: 'blob' });

export const getBillsDetailCustom = (params) =>
    api.get('/statistics/bills-detail-custom', { params });

export const getRevenueBookCustom = (params) =>
    api.get('/statistics/bills-revenue-book-custom', { params });

export const getCustomerChart = (params) =>
    api.get('/statistics/customer-chart', { params });

export const getCustomerChartCustom = (params) =>
    api.get('/statistics/customer-chart-custom', { params });

export const getRevenueChart = (params) =>
    api.get('/statistics/revenue-chart', { params });

export const getRevenueChartCustom = (params) =>
    api.get('/statistics/revenue-chart-custom', { params });
